import { render, staticRenderFns } from "./RegisterModel.vue?vue&type=template&id=940326ce&"
import script from "./RegisterModel.vue?vue&type=script&lang=js&"
export * from "./RegisterModel.vue?vue&type=script&lang=js&"
import style0 from "./RegisterModel.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RegisterModel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports